import { render, staticRenderFns } from "./DoctorUser.vue?vue&type=template&id=2bc47d6f&scoped=true&"
import script from "./DoctorUser.vue?vue&type=script&lang=js&"
export * from "./DoctorUser.vue?vue&type=script&lang=js&"
import style0 from "./DoctorUser.vue?vue&type=style&index=0&id=2bc47d6f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc47d6f",
  null
  
)

export default component.exports